module.exports = __webpack_public_path__ + "img/dynamic-content-placeholder.487b1867.svg";